import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod/v4'
import SettingsOrganizationUsagePage from '@/components/pages/Settings/organization/SettingsOrganizationUsagePage/SettingsOrganizationUsagePage'

const searchSchema = z.object({
    billing_continue: z.boolean().optional(),
})

export const Route = createFileRoute('/$workspaceName/$environment/organization-settings/usage')({
    component: OrganizationUsageRoute,
    validateSearch: searchSchema,
})

function OrganizationUsageRoute() {
    return <SettingsOrganizationUsagePage />
}
